import { useLocation } from '@redwoodjs/router'

export function useSetLocation() {
  const { pathname, search: currentSearch } = useLocation()
  function getBaseUrl() {
    return window.location.protocol + '//' + window.location.host + pathname
  }
  function getSearchString(search?: Record<string, string>, replace?: boolean) {
    let searchString = search
      ? Object.keys(search)
          .map((k) => `${k}=${search[k]}`)
          .join('&')
      : ''
    if (!replace && currentSearch) {
      searchString = [currentSearch, searchString].join('&')
    }
    return searchString ? `?${searchString}` : ''
  }
  function getHashString(hash?: string) {
    return hash ? `#${hash}` : ''
  }
  return ({
    search,
    hash,
    replaceSearch,
  }: {
    search?: Record<string, string>
    hash?: string
    replaceSearch: boolean
  }) => {
    const path =
      getBaseUrl() +
      getSearchString(search, replaceSearch) +
      getHashString(hash)
    window.history.pushState({ path }, '', path)
  }
}
